import { render } from "./Documents.vue?vue&type=template&id=2e888f15&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=2e888f15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e888f15"]])

export default __exports__